import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ThemeProvider } from 'styled-components'

// Get our div classes
const widgetDivs = document.querySelectorAll('.ulysse-widget')

// Inject our React App into each class
widgetDivs.forEach((div) => {
  ReactDOM.render(
    <React.StrictMode>
      <ThemeProvider
        theme={{
          mainColor: div.dataset.color,
          secondaryColor: div.dataset.secondarycolor,
          hoverColor: div.dataset.hovercolor,
          bgColor: div.dataset.bgcolor,
        }}
      >
        <App
          partner={div.dataset.partner}
          lang={div.dataset.lang}
          origin={div.dataset.origin}
          destination={div.dataset.destination}
          departureDate={div.dataset.departureDate}
          returnDate={div.dataset.returnDate}
          tripType={div.dataset.tripType}
          affilaeId={div.dataset.affilaeId}
        />
      </ThemeProvider>
    </React.StrictMode>,
    div
  )
})

reportWebVitals()
